<template>
  <Form
    v-if="!tabLoading"
    :data="branding"
    @color-change="brandingChange"
    @dirty-tab="setDirtyTab"
    @update-image="updateImage"
  />
</template>

<script>
import Form from '@/components/Dashboard/SettingsBrandingForm';
import { createNamespacedHelpers } from 'vuex';
const { mapGetters, mapActions } = createNamespacedHelpers('settings/branding');

export default {
  components: {
    Form,
  },
  computed: {
    ...mapGetters(['branding']),
    tabLoading() {
      return this.$store.getters['tabLoading'];
    },
  },
  methods: {
    ...mapActions([
      'fetchBranding',
      'brandingChange',
      'updateImage',
      'setDirtyTab',
    ]),
  },
};
</script>
